
    /**
    * 修改样品间
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  /**
 * SampleRoomParam :SampleRoomParam
 */
export class IReqid17416 {
  sampleRoomNo?: {};
  /**
   * 样品间名称
   */
  sampleName?: {};
  /**
   * 负责人姓名
   */
  realName?: {};
  /**
   * 负责人联系方式
   */
  mobileNumber?: {};
  sampleAddress?: {};
  /**
   * 0正常
   */
  status?: {};
  /**
   * 分页
   */
  index?: {};
  size?: {};
}
  /**
 * YResult :YResult
 */
export class IResid17416 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid17416, IResid17416 > = (data?) =>  request({
        method: 'POST',
        url: '/admin/sampleRoom/updateSampleRoom',
        data: data
      }) 
  export default http